import { DatePipe } from '@angular/common';
import {
  Component,
  ElementRef,
  HostListener,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  FormGroup,
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import * as alerts from '../../_functions/alerts';
import { dropDown } from '../../_models/components-types.interface';
import { Membro } from '../../_models/membro';
import {
  MessageRequetModel,
  SmsRequestModel,
} from '../../_models/smsRequestModel';
import { AuthService } from '../../_services/auth.service';
import { FidelidadeService } from '../../_services/fidelidade.service';
import { DynamicFormComponent } from '../../_shared/components/dynamic-form/dynamic-form.component';

@Component({
  selector: 'app-meusdados',
  templateUrl: './meusdados.component.html',
  styleUrls: ['./meusdados.component.scss'],
  providers: [],
})
export class MeusDadosComponent implements OnInit {
  @ViewChild('msgRetorno', { static: false }) msgRetorno: ElementRef;
  // ** CONSTANTES ** //
  readonly CAMPO_TELEFONE: string = 'telefone';
  readonly CAMPO_EMAIL: string = 'email';
  readonly CAMPO_SENHA: string = 'senha';
  readonly CAMPO_CONFIRMACAO_SENHA: string = 'confirmacaoSenha';
  readonly ICONE_OLHO_ABERTO: string = 'assets/images/icons/olho_aberto.png';
  readonly ICONE_OLHO_FECHADO: string = 'assets/images/icons/olho_fechado.png';

  membroForm: UntypedFormGroup;
  membro: Membro = new Membro();
  enderecos: any[] = [];

  // ** Variaveis de controle ** //
  exibePopupGenerico: boolean = false;
  exibirModalAceiteInvalido: boolean = false;
  exibirPopupTerminoContaOne: boolean = false;
  exibirModalComunicacao: boolean = false;
  aceiteTermosBtn: boolean = false;
  exibirPopupGenerico: boolean = false;
  exibirModalValidacaoDados: boolean = false;
  exibirBotaoReenviar: boolean = true;
  tipoCampoSenha: boolean = false;
  tipoCampoConfirmacaoSenha: boolean = false;
  iconeSenha: string = this.ICONE_OLHO_FECHADO;
  iconeConfirmacaoSenha: string = this.ICONE_OLHO_FECHADO;
  controleFormEndereco: boolean = true;
  aceiteFeito: boolean = false;
  // ** strings ** //
  telefoneAntigo: string = '';
  emailAntigo: string = '';
  tituloModalGenerico: string = '';
  descricaoModalGenerico: string = '';
  descricaoBotaoModalGenerico: string = '';
  descricaoSegundosModalValidacaoDados: string = '';
  mensagensErros: string[] = [];
  updateStatus = false;
  senhaObrigatoria = false;

  // ** int ** //
  tamanhoInputValidacao: Array<number> = [1, 2, 3, 4, 5, 6];
  time: number = 0;
  interval: any;

  salvandoMembro: boolean = false;
  confirmaExclusao: boolean = false;

  formConfirmaExclusao: FormGroup;

  isDisable = false;

  valorGenero: dropDown[] = [
    {
      label: 'Masculino',
      value: 'M',
    },
    {
      label: 'Feminino',
      value: 'F',
    },
    {
      label: 'Prefiro não informar',
      value: 'N',
    },
  ];

  @ViewChild(DynamicFormComponent) form: DynamicFormComponent;

  // Tamanho tela
  public width: number = 0;
  public height: number = 0;

  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    this.obterTamanhoDaTela();
  }

  constructor(
    private fidelidadeService: FidelidadeService,
    private datepipe: DatePipe,
    private authService: AuthService,
    private router: Router,
    private fb: UntypedFormBuilder,
    private el: ElementRef
  ) {
    this.obterTamanhoDaTela();
  }

  ngOnInit(): void {
    this.obterMembro();
    this.registrarForm();
    this.obterListaDeEnderecos();
  }

  private obterTamanhoDaTela(): void {
    this.width =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth;
    this.height =
      window.innerHeight ||
      document.documentElement.clientHeight ||
      document.body.clientHeight;
  }

  public mostrarPopupTermos() {
    this.fidelidadeService.abrirTermoApp();
  }

  public mostrarPopupRegulamento() {
    this.fidelidadeService.abrirRegulamento();
  }

  private registrarForm() {
    this.formConfirmaExclusao = this.fb.group({
      exclusao: [''],
    });

    this.membroForm = this.fb.group({
      nome: ['', [Validators.required]],
      nomeSocial: ['', Validators.required],
      cpf: ['', Validators.required],
      dataNascimento: ['', [Validators.required]],
      dataCadastro: ['', []],
      telefone: ['', [Validators.required, Validators.minLength(11)]],
      genero: ['', [Validators.required]],
      email: ['', []],
      senha: [
        '',
        [
          Validators.pattern(
            '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])[A-Za-z\\d$@$!%*?&].{7,}$'
          ),
        ],
      ],
      senhaConfirmacao: [
        '',
        [
          Validators.pattern(
            '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])[A-Za-z\\d$@$!%*?&].{7,}$'
          ),
        ],
      ],
      aceiteTermo: [],
      atributosForm: this.fb.array([]),
    });
  }

  private obterMembro() {
    this.fidelidadeService.obterMembro().subscribe(
      (sucesso) => {
        if (sucesso.tipoStatus === 7 || sucesso.tipoStatus === 11) {
          this.updateStatus = true;
          this.exibirPopupGenerico = true
          this.mostrarPopupTermos();
        } else {
          this.updateStatus = false;
        }
        this.processarSucessoObterMembro(sucesso);
      },
      (falha) => {
        this.processarFalhaObterMembro(falha);
      }
    );
  }

  private obterListaDeEnderecos() {
    this.fidelidadeService.obterEnderecosMembro().subscribe(
      (sucesso) => {
        this.preencherEndereco(sucesso);
        this.exibirFormEndereco();
      },
      (falha) => {
        console.error('Erro ao obter lista de enderecos do membro');
        this.exibirFormEndereco();
      }
    );
  }

  private preencherEndereco(result: any) {
    let i = 0;
    for (let item of result) {
      this.enderecos.push({
        idMembro: item.idMembro,
        enderecoPrincipal: item.enderecoPrincipal,
        descricao: item.descricao,
        cep: item.cep,
        logradouro: item.logradouro,
        bairro: item.bairro,
        cidade: item.cidade,
        estado: item.estado,
        numero: item.numero,
        complemento: item.complemento,
        pais: item.pais,
        idControle: i,
      });
      i++;
    }
  }

  private preencherForm() {
    if (this.membro) {
      this.membroForm.patchValue({
        nome: this.membro.nome,
        nomeSocial: this.membro.nomeSocial,
        cpf: this.membro.cpf,
        dataNascimento: this.formatarDataNascimento(
          this.membro.dataNascimento,
          'ddMMyyyy'
        ),
        dataCadastro: this.formatarDataNascimento(
          this.membro.dataInclusao,
          'ddMMyyyy'
        ),
        telefone: this.membro.telefone,
        genero: this.membro.genero,
        email: this.membro.email,
        aceiteTermo: this.membro.aceiteTermo,
        senha: '',
        senhaConfirmacao: '',
        atributosForm: this.adicionarAtributos(),
      });
      if (this.membro.tipoStatus == 7 || this.membro.tipoStatus == 11) {
        this.membroForm.get('nome').enable();
        this.membroForm.get('dataNascimento').enable();
        this.membroForm.get('cpf').disable();
        this.membroForm.get('dataCadastro').disable();
      } else {
        this.membroForm.get('nome').disable();
        this.membroForm.get('cpf').disable();
        this.membroForm.get('dataNascimento').disable();
        this.membroForm.get('dataCadastro').disable();
      }
    }
  }

  adicionarAtributos() {
    let atributosForm = this.membroForm.get(
      'atributosForm'
    ) as UntypedFormArray;
    atributosForm.clear();
    if (this.membro.atributos?.length > 0) {
      for (let index = 0; index < this.membro.atributos.length; index++) {
        if (this.membro.atributos[index].atributoRelacao[0]?.valor != null) {
          atributosForm.push(
            this.fb.group({
              id: this.membro.atributos[index].id,
              valor: this.membro.atributos[index].atributoRelacao[0].valor,
              descricao: this.membro.atributos[index].descricao,
              tipo: this.membro.atributos[index].tipo,
            })
          );
        }
      }
    }
  }

  validarEmailRequerido() {
    this.membroForm.controls['email'].setValidators([
      Validators.required,
      Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,4}$'),
    ]);

    if (
      this.membroForm.value.dataNascimento != undefined &&
      this.membroForm.value.dataNascimento.length == 8
    ) {
      const nascimento: string = this.membroForm.value.dataNascimento;
      const dia = Number(nascimento.substring(0, 2));
      const mes = Number(nascimento.substring(2, 4));
      const ano = Number(nascimento.substring(4, 8));

      var dataFinal = `${ano}/${mes}/${dia}`;

      const nascimentoDate: Date = new Date(dataFinal);

      let age = this.getAge(nascimentoDate);

      if (age >= 65) {
        this.membroForm.controls['email'].clearValidators();
        this.membroForm.value.email = null;
      }
    }

    this.membroForm.controls['email'].updateValueAndValidity();
  }

  validarEnderecoRequerido() {
    if (this.membroForm.value.codigoPostal.length <= 0) {
      this.membroForm.value.pais = '';
      this.membroForm.value.estado = '';
      this.membroForm.value.cidade = '';
      this.membroForm.value.bairro = '';
      this.membroForm.value.endereco = '';
      this.membroForm.value.complemento = '';
      this.membroForm.value.numero = '';

      this.membroForm.controls['endereco'].clearValidators();
      this.membroForm.controls['numero'].clearValidators();
    }

    this.membroForm.controls['endereco'].updateValueAndValidity();
    this.membroForm.controls['numero'].updateValueAndValidity();
  }

  editarMembro() {
    this.validarEmailRequerido();

    if (this.membroForm.valid) {
      // ** limpar mensagens de validacoes
      this.mensagensErros = [];

      if (this.membro.tipoStatus == 7 || this.membro.tipoStatus == 11) {
        if (
          this.membroForm.get('aceiteTermo').value !== true &&
          this.membro.tipoStatus === 7
        ) {
          this.membro.tipoStatus = 7;
        }
        if (
          this.membroForm.get('aceiteTermo').value !== true &&
          this.membro.tipoStatus === 11
        ) {
          this.membro.tipoStatus = 11;
        }
        if (
          this.membroForm.get('aceiteTermo').value === true &&
          this.membro.tipoStatus === 11
        ) {
          this.membro.tipoStatus = 1;
        }
        if (
          this.membroForm.get('aceiteTermo').value === true &&
          this.membro.tipoStatus === 7
        ) {
          this.membro.tipoStatus = 1;
        }
      }

      if (!this.membro.atributos)
        this.membro.atributos[0].atributoRelacao = null;

      // ** campos imutaveis
      this.membro.nome = this.membro.nome;
      this.membro.cpf = this.membro.cpf;

      // ** mapea membroForm para membro
      this.membro = Object.assign({}, this.membro, this.membroForm.value);

      if (this.senhaObrigatoria && !this.membroForm.value.senha) {
        this.mensagensErros.push('Preencha a senha.');
        this.scrollToTop();
        return;
      }
      // ** validação de data

      this.membroForm.get('dataNascimento').enable();
      this.membro.dataNascimento = this.formarDataNascimentoParaDate(
        this.membroForm?.value?.dataNascimento
      );
      this.membroForm.get('dataNascimento').disable();

      const dataAtual = new Date();
      const idade =
        dataAtual.getFullYear() - this.membro.dataNascimento.getFullYear();

      if (idade < 18) {
        this.mensagensErros.push(
          'Idade mínima não atingida para ser um Cacau Lover.'
        );
        this.scrollToTop();
        return;
      } else if (idade > 120) {
        this.mensagensErros.push('Idade máxima atingida.');
        this.scrollToTop();
        return;
      }

      // ** validação de senha
      if (
        !this.membroForm.value.senha &&
        !this.membroForm.value.confirmarSenha
      ) {
        this.membro.senha = null;
        this.membro.senhaConfirmacao = null;
      } else {
        if (this.membro.senha != this.membro.senhaConfirmacao) {
          this.mensagensErros.push('As senhas não são iguais.');
          this.scrollToTop();
          return;
        }
      }

      this.membro.telefone = '55' + this.membro.telefone;

      this.membro.aceiteTermo = this.membro.aceiteTermo;

      // Envia comunicação deve sempre receber o mesmo valor que aceite de termo
      this.membro.enviaComunicacao = this.membro.aceiteTermo;

      this.membro.enderecosMembro = this.enderecos;

      this.membro.atributos = this.membroForm.controls['atributosForm'].value;

      this.salvandoMembro = true;

      this.fidelidadeService
        .atualizarMembro(this.membro, this.membro.email ?? this.membro.cpf)
        .subscribe(
          (sucesso) => {
            this.processarSucessoAtualizarMembro(sucesso);
            this.authService.LocalStorage.salvarMembro(sucesso);
            //console.log('sucesso: ', sucesso);
          },
          (falha) => {
            this.processarFalhaAtualizarMembro(falha);
            //console.log('falha: ', falha);
          }
        );
    }
  }

  aceiteTermosInit() {
    this.salvandoMembro = true
    this.membro.aceiteTermo = true;
    this.membro.enviaComunicacao = true;
    this.membro.senha = null;
    this.membro.senhaConfirmacao = null;
    this.membro.telefone = '55' + this.membro.telefone;
    this.fidelidadeService
      .atualizarMembro(this.membro, this.membro.email ?? this.membro.cpf)
      .subscribe(
        (sucesso) => {
          this.processarSucessoAtualizarMembro(sucesso);
          this.authService.LocalStorage.salvarMembro(sucesso);
        },
        (falha) => {
          this.processarFalhaAtualizarMembro(falha);
        },
        () => {
          this.aceiteTermosBtn = false
          this.salvandoMembro = false
        }
      );
  }

  // ** EVENTOS DE TELA ** //
  exibirPopupSemAceite() {
    this.exibirPopupTerminoContaOne = false;

    this.tituloModalGenerico = 'Parece que está faltando algo...';
    this.descricaoModalGenerico =
      'Complete seu cadastro, leia e aceite os termos do programa.';
    this.descricaoBotaoModalGenerico = 'Ok';

    this.exibirPopupGenerico = true;
  }

  exibirPopupTerminoConta() {
    this.exibirPopupTerminoContaOne = true;
  }

  exibirPopupComunicacao(evento: any) {
    if (evento.checked || !this.membro.aceiteTermo) {
      this.aceiteFeito = false;
      return;
    }
    if (this.membroForm.controls['aceiteTermo'].value === false) {
      this.exibirModalComunicacao = true;
    }
    this.aceiteFeito = true;
  }

  excluirCadastro() {
    this.salvandoMembro = true;
    this.ObterIp().then((ip) => {
      this.invativarCadastro(ip);
    });
  }

  exibirPopupValidacaoDados(campoValidacao: string) {
    if (
      campoValidacao == this.CAMPO_TELEFONE &&
      this.membroForm.value.telefone !== this.telefoneAntigo
    ) {
      Swal.fire('Seu telefone foi alterado! salve o novo número para validar');
      return;
    }

    if (
      campoValidacao == this.CAMPO_EMAIL &&
      this.membroForm.value.email !== this.emailAntigo
    ) {
      Swal.fire('Seu e-mail foi alterado! salve o novo e-mail para validar');
      return;
    }

    this.tituloModalGenerico = campoValidacao;
    this.descricaoModalGenerico = '';
    this.setarVisibilidadeModalValidacaoDados(true);

    if (campoValidacao == this.CAMPO_TELEFONE) {
      this.dispararSms();
    } else if (campoValidacao == this.CAMPO_EMAIL) {
      this.dispararEmail();
    }
  }

  validarCodigo(indexInput: number, campoValidacao: string, event: any) {
    let pinCode: string = '';

    if (indexInput < 6 && event.target.value !== '') {
      const id = 'input_validacao_dados_' + (indexInput + 1);
      var input = <HTMLInputElement>document.getElementById(id);
      if (input !== null) input.focus();
    }

    for (let index = 0; index < this.tamanhoInputValidacao.length; index++) {
      const id = 'input_validacao_dados_' + index;
      pinCode += (<HTMLInputElement>document.getElementById(id)).value;
    }

    if (pinCode.length < 6) return;

    if (campoValidacao == this.CAMPO_TELEFONE) this.validarSms(pinCode);
    else if (campoValidacao == this.CAMPO_EMAIL) this.validarEmail(pinCode);
  }

  cancelarExclucao() {
    this.exibirPopupTerminoContaOne = false;
  }

  cancelarComunicacao() {
    this.exibirModalComunicacao = false;

    this.setarCheckComunicacaoComoTrue();
  }

  fecharModalComunicacao() {
    this.exibirModalComunicacao = false;
    this.setarCheckComunicacaoComoTrue();
  }

  pararDeReceberComunicacao() {
    this.exibirModalComunicacao = false;

    this.setarCheckComunicacaoComoFalse();
  }

  trocarTipoCampoSenha(campoValidacao: string, icone: string) {
    if (campoValidacao === this.CAMPO_SENHA) {
      this.tipoCampoSenha = !this.tipoCampoSenha;
      this.iconeSenha = this.obterIconeSenha(icone);
    } else if (campoValidacao === this.CAMPO_CONFIRMACAO_SENHA) {
      this.tipoCampoConfirmacaoSenha = !this.tipoCampoConfirmacaoSenha;
      this.iconeConfirmacaoSenha = this.obterIconeSenha(icone);
    }
  }

  cancelarFormEndereco(): void {
    this.controleFormEndereco = !this.controleFormEndereco;
  }

  incluirNovoEndereco(endereco: any): void {
    this.cancelarFormEndereco();
    var ultimoId =
      this.enderecos.length > 0
        ? Math.max(...this.enderecos.map((x) => x.idControle))
        : -1;
    endereco.idControle = ultimoId + 1;
    this.enderecos.push(endereco);
  }

  removerEndereco(idControle: any): void {
    this.enderecos = this.enderecos.filter(function (el) {
      return el.idControle != idControle;
    });
    this.exibirFormEndereco();
  }

  tornarEnderecoPrincipal(idControle): void {
    for (let item of this.enderecos) {
      if (item.idControle == idControle) item.enderecoPrincipal = true;
      else item.enderecoPrincipal = false;
    }
  }

  atualizarEndereco(enderecoRequest: any): void {
    var endereco = this.enderecos.filter(
      (x) => x.idControle === enderecoRequest.idControle
    );
    for (let item of endereco) {
      (item.descricao = enderecoRequest.descricao),
        (item.cep = enderecoRequest.cep),
        (item.logradouro = enderecoRequest.logradouro),
        (item.bairro = enderecoRequest.bairro),
        (item.cidade = enderecoRequest.cidade),
        (item.estado = enderecoRequest.estado),
        (item.numero = enderecoRequest.numero),
        (item.complemento = enderecoRequest.complemento),
        (item.pais = enderecoRequest.pais);
    }
  }

  exibirFormEndereco(): void {
    this.controleFormEndereco = this.enderecos?.length === 0 ? false : true;
  }

  // ** METODOS PRIVADOS DE APOIO **//
  private ObterIp() {
    return new Promise((resolve, reject) => {
      this.authService.getIPAddress().subscribe(
        (res) => {
          resolve(res.ip);
        },
        (falha) => {
          this.falhaAoInativarMembro();
        }
      );
    });
  }

  private invativarCadastro(ip: any) {
    this.fidelidadeService
      .inativarPorCpf(
        ip,
        this.authService.LocalStorage.obterToken(),
        this.membro.cpf
      )
      .subscribe(
        (sucesso) => {
          this.sucessoAoInativarMembro();
          this.authService.LocalStorage.desconectar();

          this.salvandoMembro = false;

          setTimeout(() => {
            this.router.navigate(['/']);
          }, 5000);
        },
        (falha) => {
          this.salvandoMembro = false;

          this.falhaAoInativarMembro();
        }
      );
  }

  private setarCheckComunicacaoComoTrue() {
    this.membroForm.patchValue({
      aceiteTermo: true,
    });
  }

  private setarCheckComunicacaoComoFalse() {
    this.membroForm.patchValue({
      aceiteTermo: false,
    });
  }

  private iniciarContagemRegressiva() {
    this.limparCamposModalGenerico();

    this.time = 300;
    this.interval = setInterval(() => {
      if (this.time === 0) {
        clearInterval(this.interval);
        this.descricaoSegundosModalValidacaoDados = 'Código expirado!';
        this.setarVisibilidadeBotaoReenviar(false);
      } else {
        this.time--;
        this.descricaoSegundosModalValidacaoDados =
          '<img class="opcao__icone icone_timer" src="assets/images/icons/timer.png"/> ' +
          this.time +
          's';
        this.setarVisibilidadeBotaoReenviar(true);
      }
    }, 1000);
  }

  private limparCamposModalGenerico(): void {
    for (let index = 0; index < this.tamanhoInputValidacao.length; index++) {
      const id = 'input_validacao_dados_' + index;
      let input = <HTMLInputElement>document.getElementById(id);
      if (input !== null) input.value = '';
    }
  }

  private setarVisibilidadeBotaoReenviar(show: boolean) {
    this.exibirBotaoReenviar = show;
  }

  private setarVisibilidadeModalValidacaoDados(show: boolean) {
    this.exibirModalValidacaoDados = show;
  }

  private dispararSms() {
    this.fidelidadeService
      .enviarSmsValidarCampo(this.obterSmsRequestModel())
      .subscribe(
        (sucesso) => {
          this.processarSucessoEnvioSms(sucesso);
        },
        (falha) => {
          this.processarFalhaEnvioSms(falha);
        }
      );
  }

  private dispararEmail() {
    this.fidelidadeService.enviarEmailValidarCampo(this.membro).subscribe(
      (sucesso) => {
        this.processarSucessoEnvioEmail(sucesso);
      },
      (falha) => {
        this.processarFalhaEnvioEmail(falha);
      }
    );
  }

  private validarSms(pinCode: string) {
    this.fidelidadeService
      .validarPinCodeSmsValidarCampo(this.obterSmsRequestModel(), pinCode)
      .subscribe(
        (sucesso) => {
          if (sucesso.resultado == true) {
            this.fidelidadeService.obterMembro().subscribe(
              (sucesso: Membro) => {
                sucesso.telefoneValidado = true;
                sucesso.senha = null;

                this.fidelidadeService
                  .atualizarMembro(sucesso, sucesso.email ?? sucesso.cpf)
                  .subscribe(
                    (sucesso) => {
                      this.setarVisibilidadeModalValidacaoDados(false);
                      this.authService.LocalStorage.salvarMembro(sucesso);
                      this.processarSucessoAtualizarMembro(sucesso);
                    },
                    (falha) => {
                      this.processarFalhaAtualizarMembro(falha);
                    }
                  );
              },
              (falha) => {
                this.processarFalhaObterMembro(falha);
              }
            );
          } else {
            alerts.exibirToast('error', 'Código informado inválido!');
            return;
          }
        },
        (falha) => { }
      );
  }

  private validarEmail(pinCode: string) {
    this.fidelidadeService
      .validarPinCodeEmailValidarCampo(this.membro, pinCode)
      .subscribe(
        (sucesso) => {
          if (sucesso.resultado == true) {
            this.fidelidadeService.obterMembro().subscribe(
              (sucesso: Membro) => {
                sucesso.emailValidado = true;
                sucesso.senha = null;

                this.fidelidadeService
                  .atualizarMembro(sucesso, sucesso.email ?? sucesso.cpf)
                  .subscribe(
                    (sucesso) => {
                      this.setarVisibilidadeModalValidacaoDados(false);
                      this.authService.LocalStorage.salvarMembro(sucesso);
                      this.processarSucessoAtualizarMembro(sucesso);
                    },
                    (falha) => {
                      this.processarFalhaAtualizarMembro(falha);
                    }
                  );
              },
              (falha) => {
                this.processarFalhaObterMembro(falha);
              }
            );
          } else {
            alerts.exibirToast('error', 'Código informado inválido!');
            return;
          }

          this.salvandoMembro = false;
        },
        (falha) => {
          this.salvandoMembro = false;
        }
      );
  }

  private obterSmsRequestModel(): SmsRequestModel {
    var smsRequestModel: SmsRequestModel = new SmsRequestModel();

    var messages: MessageRequetModel[] = [
      {
        to: '55' + this.membro.telefone.toString(),
        body: '',
      },
    ];

    smsRequestModel.messages = messages;

    return smsRequestModel;
  }

  private obterIconeSenha(icone: string) {
    if (icone.includes(this.ICONE_OLHO_FECHADO)) return this.ICONE_OLHO_ABERTO;
    else return this.ICONE_OLHO_FECHADO;
  }

  // ** METODOS PRIVADOS DE SUCESSO OU INSUCESSO **//
  private processarSucessoObterMembro(response: Membro) {
    response.telefone = response.telefone.substring(2);

    this.telefoneAntigo = response.telefone;
    this.membroForm.value.telefone = response.telefone;
    this.emailAntigo = response.email;
    this.membroForm.value.email = response.email;

    this.membro = response;
    this.preencherForm();
  }

  private processarFalhaObterMembro(err: any) {
    console.error(err);
  }

  private processarSucessoAtualizarMembro(result: any) {
    this.salvandoMembro = false;
    this.tituloModalGenerico = 'Uouuuuu';
    this.descricaoModalGenerico = 'Dados atualizado com sucesso! :)';
    this.descricaoBotaoModalGenerico = 'Fechar';

    this.exibirPopupGenerico = true;

    this.obterMembro();
    this.enderecos = [];
    this.obterListaDeEnderecos();
  }

  private processarFalhaAtualizarMembro(err: any) {
    this.tituloModalGenerico = 'Atenção :(';
    this.descricaoModalGenerico = err;
    this.descricaoBotaoModalGenerico = 'Fechar';

    this.exibirPopupGenerico = true;
    this.salvandoMembro = false;
  }

  // ** METODOS DE FORMATAÇÃO **//
  private formatarDataNascimento(data: Date, format: string) {
    return this.datepipe.transform(data, format);
  }

  private formarDataNascimentoParaDate(data: Date) {
    var dataToString = data.toString();

    const dia = parseInt(dataToString.substring(0, 2));
    const mes = parseInt(dataToString.substring(2, 4)) - 1;
    const ano = parseInt(dataToString.substring(4));

    return new Date(ano, mes, dia);
  }

  private falhaAoInativarMembro() {
    this.exibirPopupTerminoContaOne = false;

    this.tituloModalGenerico = 'Ops, não rolou...';
    this.descricaoModalGenerico =
      'Desculpe! O sistema encontra-se indisponivel!';
    this.descricaoBotaoModalGenerico = 'Fechar';

    this.exibirPopupGenerico = true;
  }

  private sucessoAoInativarMembro() {
    this.exibirPopupTerminoContaOne = false;

    this.tituloModalGenerico = 'A gente se vê';
    this.descricaoModalGenerico =
      'Às vezes o relacionamento termina, mas o amor continua vivo no coração.';
    this.descricaoModalGenerico += '<br/>A gente ainda vai se esbarrar por aí!';
    this.descricaoBotaoModalGenerico = 'Fechar';

    this.exibirPopupGenerico = true;
  }

  private processarSucessoEnvioSms(response: any) {
    this.iniciarContagemRegressiva();
  }

  private processarFalhaEnvioSms(response: any) {
    this.descricaoModalGenerico =
      'Não foi possível enviar o sms, por favor, verificar o número de telefone cadastrado.';
  }

  private processarSucessoEnvioEmail(response: any) {
    this.iniciarContagemRegressiva();
  }

  private processarFalhaEnvioEmail(response: any) {
    this.descricaoModalGenerico =
      'Não foi possível enviar o codigo, por favor, verificar o e-mail cadastrado.';
  }

  getAge(birthDate: Date) {
    var today = new Date();
    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  }

  ValidarTelefoneBlur(): void {
    let telefone: string = this.membroForm.value.telefone;

    let codTelefone = '';

    if (telefone.length > 2) codTelefone = telefone.substring(0, 2);
    else return;

    if (telefone.length === 11) {
      telefone = '55' + telefone;
    }

    this.membroForm.patchValue({ telefone: telefone });
  }

  public buscarCep(evento: any): void {
    const cep = evento.target.value.replace('-', '');
    if (cep.length !== 8) return;

    this.fidelidadeService.obterCep(cep).subscribe(
      (res) => this.processarSucessoBuscaCep(res),
      (err) => this.processarFalhaBuscaCep(err)
    );
  }
  private processarSucessoBuscaCep(res: any): void {
    this.membroForm.controls['pais'].setValue('Brasil');
    this.membroForm.controls['estado'].setValue(res.uf);
    this.membroForm.controls['cidade'].setValue(res.localidade);
    this.membroForm.controls['bairro'].setValue(res.bairro);
    this.membroForm.controls['endereco'].setValue(res.logradouro);

    this.membroForm.controls['endereco'].enable();
    this.membroForm.controls['complemento'].enable();
    this.membroForm.controls['numero'].enable();

    const enderecoControl = this.el.nativeElement.querySelector(
      '[formcontrolname="numero"]'
    );
    enderecoControl.focus();
  }

  private processarFalhaBuscaCep(err: any): void {
    this.membroForm.controls['codigoPostal'].setValue('');
    this.membroForm.controls['pais'].setValue('');
    this.membroForm.controls['estado'].setValue('');
    this.membroForm.controls['cidade'].setValue('');
    this.membroForm.controls['bairro'].setValue('');
    this.membroForm.controls['endereco'].setValue('');
    this.membroForm.controls['complemento'].setValue('');
    this.membroForm.controls['numero'].setValue('');

    this.membroForm.controls['endereco'].disable();
    this.membroForm.controls['complemento'].disable();
    this.membroForm.controls['numero'].disable();

    this.descricaoModalGenerico =
      'Não foi possível encontrar o endereço pelo código postal informado! Por favor, verificar!!';

    this.descricaoBotaoModalGenerico = 'Fechar';

    this.exibirPopupGenerico = true;
  }

  public confirmValidFields() {
    const invalidFields: string[] = [];

    for (let key in this.membroForm.controls) {
      let status = this.membroForm.controls[key].status;

      if (status == 'INVALID') {
        switch (key) {
          case 'codigoPostal':
            key = 'de endereço';
            break;
          case 'numero':
            key = 'número';
            break;
        }

        this.membroForm.controls[key].markAsTouched();

        invalidFields.push(key);
      }
    }

    if (invalidFields.length > 0) {
      let lastField = null;

      if (invalidFields.length > 1) lastField = invalidFields.pop();

      let invalidFieldsText = invalidFields.join(', ');

      if (lastField != null) invalidFieldsText += ` e ${lastField}`;

      Swal.fire({
        icon: 'warning',
        title: 'Informações inválidas.',
        text: `${invalidFields.length > 1 ? 'Os campos' : 'O campo'
          } ${invalidFieldsText} ${invalidFields.length > 1 ? 'são obrigatórios' : 'é obrigatório'
          }, verique se preencheu corretamente.`,
      });

      return;
    }

    if (this.membroForm.get('aceiteTermo').value !== true) {
      this.exibirModalAceiteInvalido = true;
    }
    if (this.membroForm.get('aceiteTermo').value === true) {
      this.editarMembro();
    }
  }

  public aceitarTermo() {
    this.exibirModalAceiteInvalido = false;
    this.setarCheckComunicacaoComoTrue();
    return;
  }

  public recusarTermo() {
    this.exibirModalAceiteInvalido = false;
    this.editarMembro();
  }

  public campo(p: any) {
    let input = document.getElementsByTagName('input')[p];
    if (input.value != '') {
    } else {
      alert('vazio');
    }
  }

  irParaAjuda(): void {
    this.router.navigate(['/ajuda']);
  }

  isDisabled(): string {
    const niveisLiberaCampo = [7, 12];
    if (niveisLiberaCampo.includes(this.membro?.tipoStatus)) {
      return 'true';
    }
  }

  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
